export default "__VITE_ASSET__2Ji8rqoO__"